import { Component } from "react";
import { datadogRum } from "@datadog/browser-rum";

// HTS Assist chat is non-critical chrome layered on top of the RBC portal.
// A render error in the widget (e.g. its own React-19-only code paths) must
// never be allowed to unmount/blank the host portal, so this boundary hides
// the widget silently (renders null) instead of showing any fallback UI that
// could otherwise cover the page. See ASSIST-609.
export class HtsAssistChatWidgetErrorBoundary extends Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    try {
      datadogRum.addError(error, {
        errorInfo,
        feature: "hts-assist-chat-widget",
      });
    } catch (loggingError) {
      console.error(
        "[HtsAssistChatWidget] Failed to report render error to Datadog RUM",
        loggingError
      );
    }

    console.error("[HtsAssistChatWidget] render error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
